
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont les effets secondaires?`}</em></p>
    <p>{`Les études sur les vaccins contre le coronavirus n’en sont pas toutes au même
stade. Pour ceux qui ont déjà obtenu une autorisation, ce qui n'est
`}<a parentName="p" {...{
        "href": "https://www.yalemedicine.org/news/covid-19-vaccine-comparison"
      }}>{`pas le cas ici`}</a>{`,
on dispose de plus d’informations et de l’expérience du terrain. Après leur
commercialisation, les produits continuent en effet de faire l’objet d’un suivi.`}</p>
    <p>{`De manière générale pour les vaccins contre le Covid, on a surtout annoncé
jusqu’à présent des réactions au site d’injection (notamment des rougeurs), des
douleurs musculaires ou articulaires, des frissons, des maux de tête, de la
fièvre… De telles réactions sont fréquentes lors d’un vaccin.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;